import { request } from '@/utils/request';

/**
 * 用户相关api
 */
/**
 * 获取用户信息
 * @param params
 * @param payload
 * @returns
 */
export const _getUserInfo = (params?: any, payload?: Request.IPayload) => {
  return request('/login/getUserInfo', params, payload);
};

export const _getAuthInfo = (params?: any, payload?: Request.IPayload) => {
  return request(
    '/micro/getAuthCenterData',
    {
      system: 'prome-micro-recommend'
    },
    payload
  );
};
